import { APIClient } from '@innerhive-internal/innerhive-api-client';
import { ICareMap } from '../caremap/ICareMap';

export interface IExistingTag {
    name: string;
    count: number;
    lastUsedAt: string;
}

export interface IExistingTagsResponse {
    tags: IExistingTag[];
}

export class CareMapTagsClient {
    static inject = () => [APIClient];
    constructor(private apiClient: APIClient) {}

    getExistingTags = async ({
        careMap,
        sortBy = 'count'
    }: {
        careMap: ICareMap;
        sortBy?: 'count' | 'recency'
    }): Promise<IExistingTagsResponse> => {
        const params = sortBy === 'recency' ? { sortBy: 'recency' } : undefined;
        return await this.apiClient.get(careMap.links.tags, undefined, params);
    };
}
